import { HeadCellType } from "../../../utils/appConstants";

export const headCells: HeadCellType[] = [
    {
      id: "blank",
      align: "left",
      disablePadding: false,
      sortEnabled: false,
      label: "",
      width: "1%",
    },
    {
      id: "ne_port",
      align: "left",
      disablePadding: false,
      sortEnabled: false,
      tooltipTitle: "Port Name",
      label: "Port",
      width: "22%",
    },
    {
      id: "ne_status",
      align: "left",
      disablePadding: false,
      sortEnabled: false,
      tooltipTitle: "Status of cross connect",
      label: "Status",
      width: "5%",
    },
    // {
    //   id: "ne_wx",
    //   align: "left",
    //   disablePadding: false,
    //   sortEnabled: false,
    //   tooltipTitle: "Status of port with respect to real time switching",
    //   label: "WX",
    //   width: "5%",
    // },
    {
      id: "ne_blank",
      align: "left",
      disablePadding: false,
      sortEnabled: false,
      width: ".5%",
    },
    {
      id: "fe_node",
      align: "left",
      disablePadding: false,
      sortEnabled: false,
      tooltipTitle: "Far End Node",
      label: "Far End",
      width: "12%",
    },
    {
      id: "fe_port",
      align: "left",
      disablePadding: false,
      sortEnabled: false,
      tooltipTitle: "Port Name",
      label: "Port",
      width: "22%",
    },
    {
      id: "fe_status",
      align: "left",
      disablePadding: false,
      sortEnabled: false,
      tooltipTitle: "Status of cross connect",
      label: "Status",
      width: "5%",
    },
    // {
    //   id: "fe_wx",
    //   align: "left",
    //   disablePadding: false,
    //   sortEnabled: false,
    //   tooltipTitle: "Status of port with respect to real time switching",
    //   label: "WX",
    //   width: "5%",
    // },
    {
      id: "fe_blank",
      align: "left",
      disablePadding: false,
      sortEnabled: false,
      width: ".5%",
    },
    {
      id: "bandwidth_description",
      align: "left",
      disablePadding: false,
      sortEnabled: false,
      tooltipTitle: "Link Description",
      label: "Link",
      width: "22%",
    },
  ];